import { Injectable } from '@angular/core';
import { UAParser } from 'ua-parser-js';

@Injectable({
  providedIn: 'root',
})
export class AppStateService {
  private readonly uaParserData = new UAParser(navigator.userAgent).getResult();
  // private readonly breakpointService = inject(BreakpointObserver);
  //
  // private readonly breakpoints = {
  //   mobile: '(max-width: 1279.98px)',
  //   tablet:
  //     '(min-width: 600px) and (max-width: 839.98px) and (orientation: portrait), (min-width: 960px) and (max-width: 1279.98px) and (orientation: landscape)',
  //   desktop: '(min-width: 1024px)',
  // };

  // private readonly mobileBreakpoint = toSignal(
  //   this.breakpointService
  //     .observe([this.breakpoints.mobile])
  //     .pipe(map((state) => state.matches)),
  // );

  // private readonly tabletBreakpoint = toSignal(
  //   this.breakpointService
  //     .observe([this.breakpoints.tablet])
  //     .pipe(map((state) => state.matches)),
  // );
  //
  // private readonly desktopBreakpoint = toSignal(
  //   this.breakpointService
  //     .observe([this.breakpoints.desktop])
  //     .pipe(map((state) => state.matches)),
  // );

  // isMobile = computed(() => this.mobileBreakpoint() ?? false);

  // isTablet = computed(() => this.tabletBreakpoint());
  //
  // isDesktop = computed(() => this.desktopBreakpoint());

  isMobileResolution(): boolean {
    return window.innerWidth < 1025;
  }

  isTabletAndMobileResolution(): boolean {
    return window.innerWidth < 1281;
  }

  isTouchDevice(): boolean {
    if (['iOS', 'Mac OS'].includes(this.uaParserData.os.name!)) {
      return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    }
    return ['mobile', 'tablet'].includes(this.uaParserData.device.type!);
  }
}
